"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryOutput = void 0;
/**
 * Interface to define an output to a configuration query.
 *
 * Each configuration type will have it's own implementation,
 * providing enum values of the available outputs of a query.
 */
class QueryOutput {
    constructor(_name, _returnType) {
        this._name = _name;
        this._returnType = _returnType;
    }
    /**
     * Defines that data type the query output value is stored in.
     * This method can be used as a helper to identify how to read the query output.
     *
     * @return {@link DataType}
     */
    getReturnType() {
        return this._returnType;
    }
    toString() {
        return this._name;
    }
}
exports.QueryOutput = QueryOutput;
//# sourceMappingURL=query-output.js.map